"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const invoice_1 = require("@wurzel/uzb-calculation/dist/invoice");
const util_1 = require("./util");
function getVariablesInvoice(move, configuration, offer) {
    var _a, _b, _c, _d, _e, _f;
    const invoice = invoice_1.calculateInvoice(offer, move, configuration);
    const { additionalServices } = invoice;
    return {
        rechnung: util_1.getAddressVariables(util_1.getInvoiceAddress(move)),
        umzugsdatum: move.loadingDates
            .map((d) => util_1.formatDate(d.date))
            .filter((d) => !!d)
            .join(" / "),
        rechnungsnummer: invoice.number,
        rechnungsdatum: util_1.formatDate(invoice.date),
        sendungsnummer: (_b = (_a = move.documentData) === null || _a === void 0 ? void 0 : _a.invoice) === null || _b === void 0 ? void 0 : _b.sendungsnummer,
        angebotsdatum: util_1.formatDate((_d = (_c = move.documentData) === null || _c === void 0 ? void 0 : _c.offer) === null || _d === void 0 ? void 0 : _d.date),
        preisUmzug: offer.positionsSum,
        summe: invoice.total,
        mehrwertsteuer: invoice.vat,
        mehrwertsteuersatz: invoice.vatRate * 100,
        versicherungsbeitrag: offer.insuranceFee,
        barzahlung: move.paymentMethod === "cash",
        faltkartonsAbholen: !!((_f = (_e = move.documentData) === null || _e === void 0 ? void 0 : _e.invoice) === null || _f === void 0 ? void 0 : _f.pickupFoldingBoxes),
        ...Object.fromEntries(additionalServices.map((service, i) => [
            `position${i + 1}Name`,
            service.name || "",
        ])),
        ...Object.fromEntries(additionalServices.map((service, i) => [
            `position${i + 1}Menge`,
            service.amount || "",
        ])),
        ...Object.fromEntries(additionalServices.map((service, i) => [
            `position${i + 1}Einheit`,
            getUnit(service.unit || ""),
        ])),
        ...Object.fromEntries(additionalServices.map((service, i) => [
            `position${i + 1}Stkpreis`,
            service.unitPrice && service.unit
                ? `${service.unitPrice.toLocaleString("de-DE", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                })} €/${getUnit(service.unit)}`
                : "",
        ])),
        ...Object.fromEntries(additionalServices.map((service, i) => [
            `position${i + 1}Preis`,
            service.price,
        ])),
    };
}
exports.default = getVariablesInvoice;
function getUnit(unit) {
    switch (unit) {
        case "ton":
            return "t";
        case "kilogram":
            return "kg";
        case "meter":
            return "m";
        case "piece":
            return "Stk.";
        case "hour":
            return "Std.";
        default:
            return "";
    }
}
//# sourceMappingURL=invoice.js.map